<template>
     <div class="site-view">
      <Header :title="Webinar"/>
      
 
        <section class="page-section video-section">
       
            <div class="container">
                <div class="row">
                    <div class="col m12 l12">
                        <div class="text-wrap center-align">
                            <div class="mb4">
                                <p class="hr-title mb4"><hr class="hr-purple"><b>Webinar</b></p>
                                <h1>About Phase Two</h1>
                                <p class="mb2"> Learn more details on phase two, including a timeline of progress, and an introduction to the Glider brand.</p>
                                 
                                 <div class="video-box mb-4 hide-on-small-and-down show-on-medium-and-up" width="560">
                                 <!-- <iframe width="100%" height="315" src="https://player.vimeo.com/video/59b97692a4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
                                 <!-- <iframe width="100%" height="315"  src="https://player.vimeo.com/video/575038653?title=0&playsinline=0&byline=0&portrait=0&speed=0&badge=0&autopause=0&player_id=0&app_id=58479/embed" allow="autoplay; fullscreen; picture-in-picture" webkitAllowFullScreen mozAllowFullScreen allowFullScreen frameborder="0" style=""></iframe> -->
                                  <!-- <video width="100%" height="auto" controls poster="@/assets/images/a141/video/JP_Thumbnail.png">
                                    <source type="video/mp4" 
                                      src="https://www.youtube.com/watch?v=25l1bzphFPo&t=5s">
                                  </video> -->
                                  <!-- jun 2021 -->
                                  <!--
                                  <iframe width="100%" height="315"  src="https://player.vimeo.com/video/575038653?title=0&playsinline=0&byline=0&portrait=0&speed=0&badge=0&autopause=0&player_id=0&app_id=58479/embed" allow="autoplay; fullscreen; picture-in-picture" webkitAllowFullScreen mozAllowFullScreen allowFullScreen frameborder="0" style=""></iframe>
                                  -->
                                  <!-- jul 2021 -->
                                  <!-- <iframe src="https://player.vimeo.com/video/568724130" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> -->
                                   <!-- <object width="560" height="349">
                                    <param name="movie" value="https://www.youtube.com/embed/n0VW7foNpuI" />
                                    <param name="allowFullScreen" value="true" />
                                    <param name="allowscriptaccess" value="always" />
                                    <embed type="application/x-shockwave-flash" width="100%" height="315" src="https://www.youtube.com/embed/n0VW7foNpuI" allowscriptaccess="always" allowfullscreen="true">
                                    </embed>
                                  </object> -->
                                  <iframe style="height:350px;width:560px;"  src="https://www.youtube.com/embed/n0VW7foNpuI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                </div>
                                 <div class="video-box mb-4 show-on-med-and-down hide-on-med-and-up">
                                   <!-- <iframe style="height:350px;width:100%;"  src="https://www.youtube.com/embed/n0VW7foNpuI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
                                    <object width="100%" height="349">
                                    <param name="movie" value="https://www.youtube.com/embed/n0VW7foNpuI" />
                                    <param name="allowFullScreen" value="true" />
                                    <param name="allowscriptaccess" value="always" />
                                    <embed type="application/x-shockwave-flash" width="100%" height="315" src="https://www.youtube.com/embed/n0VW7foNpuI" allowscriptaccess="always" allowfullscreen="true">
                                    </embed>
                                  </object>
                                  <!-- <object width="100%" height="349">
                                    <param name="movie" value="https://player.vimeo.com/video/575038653?title=0&byline=0&portrait=0&speed=0&badge=0&autopause=0&player_id=0&app_id=58479/embed" />
                                    <param name="allowFullScreen" value="true" />
                                    <param name="allowscriptaccess" value="always" />
                                    <embed type="application/x-shockwave-flash" width="100%" height="315" src="https://player.vimeo.com/video/575038653?title=0&byline=0&portrait=0&speed=0&badge=0&autopause=0&player_id=0&app_id=58479/embed" allowscriptaccess="always" allowfullscreen="true">
                                    </embed>
                                  </object> -->
                                
                                </div>
                               
                                   <!-- https://youtu.be/X-cmERmoz_4 -->
                                   <!-- You tube new iframe,video,object

                                   IFRAMES Watch tag
                                   <iframe width="100%" height="315"  src="https://www.youtube.com/watch?v=X-cmERmoz_4" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen frameborder="0" style=""></iframe>
                                   IFRAMES Embed tag
                                  <iframe width="100%" height="315"  src="https://www.youtube.com/embed/X-cmERmoz_4" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen frameborder="0" style=""></iframe>
                                   VIdeo Watch tag
                                  <video width="100%" height="auto" controls poster="@/assets/images/a141/video/JP_Thumbnail.png">
                                    <source type="video/mp4" 
                                      src="https://www.youtube.com/watch?v=X-cmERmoz_4">
                                  </video>
                                   Object Embed tag
                                   <object width="560" height="349">
                                    <param name="movie" value="https://www.youtube.com/embed/X-cmERmoz_4" />
                                    <param name="allowFullScreen" value="true" />
                                    <param name="allowscriptaccess" value="always" />
                                    <embed type="application/x-shockwave-flash" width="100%" height="315" src="https://www.youtube.com/embed/X-cmERmoz_4" allowscriptaccess="always" allowfullscreen="true">
                                    </embed>
                                  </object> -->
                                 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <TwoColumnFooter/>
        <Footer />
    </div>
</template>

<script>
import TwoColumnFooter from "@/components/belfast/TwoColumnFooter";


import Footer from "@/components/belfast/Footer";
import Header from "@/components/belfast/HeroHeaderOtherPages"
export default {
  name: "pageWebinar",
   components: {
    Header,
    Footer,
    TwoColumnFooter
  },
  data() {
    return {
       Webinar:"Webinar"
    }
  }
};
</script>
